/**
 * The page a visitor came from on music24.com (spec 2026-10-08 onboarding §8). The website adds
 * `intent` to "Start free"; the app keeps it and changes the welcome headline and the first tour stop.
 * The file has no imports, so every project may read it.
 */
export const ONBOARDING_INTENTS = ['promote', 'analytics', 'publicData', 'teams'] as const;

export type OnboardingIntent = (typeof ONBOARDING_INTENTS)[number];

/** The intent of a value from a URL or a request, or null for any other value. */
export function parseOnboardingIntent(value: unknown): OnboardingIntent | null {
  return typeof value === 'string' && (ONBOARDING_INTENTS as readonly string[]).includes(value)
    ? (value as OnboardingIntent)
    : null;
}
